module.exports = __webpack_public_path__ + "static/meager2-f8db98264efa8587f4e2d5ccdc8f2e2f.jpg";